import React from "react";
import Modal from "react-modal";
import { TailSpin } from "react-loader-spinner";

Modal.setAppElement(document.body);

export default function RecordingLoadingDialog({ heading, subHeading, progress }) {
    return (
        <Modal
            isOpen={true}
            contentLabel="Recording/Upload Status"
            className={"modalLoading"}
            overlayClassName={"overlayLoading"}
        >
            <h2 style={{ textAlign: "center" }}>{heading}</h2>
            <p style={{ textAlign: "center", paddingTop: "20px" }}>{subHeading}</p>

            <div className="display-flex-center" style={{ marginTop: "30px" }}>
                {progress !== undefined && progress < 100 ? (
                    <progress
                        value={progress}
                        max="100"
                        style={{ width: "100%" }}
                    />
                ) : (
                    <TailSpin color="#0a7aad" height={50} width={50} />
                )}

            </div>


        </Modal>
    );
}
